export default __webpack_public_path__ + "static/media/playStore.5f2a4bb0.png";